import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { IActivitiesDashboardProps } from '../../../models/components/activities-dashboard';
import { ActivityTypeEnums } from '../../../models/enums/ActivityType';
import Content from './containers/content';
import * as types from '../../../models/action/userHome';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { SecurityContextType } from '../../../models/enums/securityContextType';
import queryString from 'querystring';
import { Common } from '../../../core/common';
import * as Actions from '../../../store/actions/userHome';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class ActivitiesDashboard extends React.Component<IActivitiesDashboardProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedActivityType: 0,
            selectedActivityName: 'All'
        };
    }

    componentDidMount() {
        const params = queryString.parse(window.location.search);
        const activityType = params.activityType;
        if (activityType) {
            this.setState({ selectedActivityName: activityType, selectedActivityType: ActivityTypeEnums[activityType as any] });
        }
    }


    selectActivityType = (activityType: number, activityName: string) => {
        this.setState({
            selectedActivityType: activityType,
            selectedActivityName: activityName
        });
        const filter = _common.HandleActivityDashboardFilter();
        filter!.activityType = activityType;
        const params = queryString.parse(window.location.search);
        window.history.pushState(null, '', '?completed=' + filter!.completed + '&activityType=' + activityName + '&classId=' + params.classId);
        this.props.dispatch(
            Actions.getUserCalendarActivities(
                SecurityContextType.Class,
                params.classId,
                filter,
                null,
                null,
                0,
                10,
                'getUserCalendarActivities',
                'get',
                this.callback, false
            )
        );
    };

    callback = (pageData: any) => {
        if (pageData.length < 10) {
            const params = queryString.parse(window.location.search);
            const filters = _common.HandleActivityDashboardFilter();
            filters.isDatePassed = 1;
            filters.dueDate = 0;
            this.props.dispatch(
                 Actions.getUserCalendarActivities(
                     SecurityContextType.Class,
                     params.classId ? params.classId.toString() : '',
                     filters,
                     null,
                     null,
                     0,
                     10,
                     'getUserCalendarActivities',
                     'get',
                     undefined,
                     true
                 )
             );
        }
    }

    public render() {
        let courseName = '';
        const params = queryString.parse(this.props.location.search);
        if (this.props.calendarActivities && this.props.calendarActivities[0] && this.props.calendarActivities[0].courseName && params.classId && params.classId !== 'undefined') {
            courseName = this.props.calendarActivities[0].courseName;
        }

        return (
            <div className="student-course  activities-dashboard">
                <div className="container">
                    <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <h2>{T.t('r_activities')} {courseName && '( ' + courseName + ' )'}</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 text-md-right">
                            <div className="align-self-center p-0">
                                <div className="options d-inline-flex align-items-center">
                                    <div className="dropdown" />
                                    <div className="dropdown lead-dropdown">
                                        <a data-toggle="dropdown" aria-expanded="false">
                                            <a style={{ color: '#7e7d7b' }}>{T.t('r_fileUpload_filter')}:</a>
                                            <label style={{ color: 'black' }} className="filter-value">
                                                {T.t('r_activity_type_' + this.state.selectedActivityName)}
                                            </label>
                                        </a>
                                        <div
                                            className="dropdown-menu x"
                                            aria-labelledby="dropdownMenuButton"
                                            x-placement="bottom-start"
                                            style={{
                                                position: 'absolute',
                                                willChange: 'transform',
                                                top: '0px',
                                                left: '0px !important',
                                                transform: 'translate3d(0px, 24px, 0px)'
                                            }}
                                        >
                                            <a
                                                className="dropdown-item"
                                                onClick={this.selectActivityType.bind(this, ActivityTypeEnums.Assignment, 'Assignment')}
                                            >
                                                {T.t('r_activity_type_Assignment')}
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={this.selectActivityType.bind(this, ActivityTypeEnums.VirtualClass, 'VirtualClass')}
                                            >
                                                {T.t('r_activity_type_VirtualClass')}
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={this.selectActivityType.bind(this, ActivityTypeEnums.Exam, 'Exam')}
                                            >
                                                {T.t('r_activity_type_Exam')}
                                            </a>
                                            <div className="dropdown-divider" />
                                            <a className="dropdown-item" onClick={this.selectActivityType.bind(this, 0, 'All')}>
                                                {T.t('r_activity_type_All')}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12" style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <Content
                                filterActivityType={this.state.selectedActivityType}
                                selectedActivityName={this.state.selectedActivityName}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivitiesDashboardProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivitiesDashboardProps = Object.assign({}, ownProps, {
        calendarActivities: state.userHomePage.userHomeCalendarActivities
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CActivitiesDashboard = connect(
    mapStateToProps,
    dispatchProps
)(ActivitiesDashboard);

export default CActivitiesDashboard;

